








import type { PropType } from '@vue/composition-api';
import { defineComponent } from '@vue/composition-api';
import type { Dictionary } from 'vue-router/types/router';
import { BaseParagraph } from '../base-paragraph';

export default defineComponent({
  name: 'BaseSubMenuItem',
  component: { BaseParagraph },
  props: {
    label: {
      type: String,
      default: '',
    },
    to: {
      type: Object as PropType<{
        path: string;
        name: string;
        params?: Dictionary<string>;
        query?: Record<string, string>;
      }>,
      default: null,
    },
    dataExternal: {
      type: String,
      default: '',
    },
    active: {
      type: Boolean,
    },
  },
  setup() {
    return {};
  },
});
